import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getAreas } from "./Axios";

const AreaSelect = props => {
  const [areas, setAreas] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "area");
  };

  useEffect(() => {
    getAreas((response) => {
      if (response && response.data) {
        const newAreas = response.data.map((area) => ({
          value: area.id,
          label: area.name,
          uniqueIdentifier: area.unique_identifier,
        }));
        setAreas(newAreas);
      }
    });
  }, []);

  return ( 
    <Select
      inputId="trabajando-area-search"
      onChange={handleChange}
      options={areas}
      placeholder="Buscar y seleccionar un área"
      value={
        areas.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default AreaSelect;

